import { handleValidation } from "./validation.js";
const formValid = () => {
    document.addEventListener('input', function (e) {
        if (e.target.id === 'billing_phone') {
            let value = e.target.value;
            value = value.replace(/[^0-9+]/g, '');
            
            value = value.replace(/\+/g, '');
            if (e.target.value.startsWith('+')) {
                value = '+' + value;
            }

            e.target.value = value;
        }

        if (e.target.id === 'billing_postcode') {
            e.target.value = e.target.value.replace(/[^A-Za-z0-9 -]/g, '');
        }
    });
}

const handleFormSubmit =  () => {
    function formSubmit() {
      document.querySelectorAll('.auto-resize').forEach(textarea => {
        textarea.addEventListener('input', () => {
          textarea.style.height = 'auto';
          textarea.style.height = textarea.scrollHeight -5 + 'px';
        });

        textarea.dispatchEvent(new Event('input'));
      });

        const forms = document.querySelectorAll('.js-sk-form');
        forms.forEach((form) => {
          const message = form.nextElementSibling;
          const submit = form.querySelector('button[type=submit]');
          const loader = form.previousElementSibling;

          form.addEventListener('submit', function(e){
            e.preventDefault()
            const valid = handleValidation(form);

            if(!valid) {
              return
            }

            submit.setAttribute('disabled', true)
            loader.classList.remove('hidden')

            const formData = new FormData(this);
            fetch(themeVars.ajax_url, {
              method: "POST",
              body: formData,
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              },
            })
            .then((response) => {
              if (!response.ok) throw new Error("Network response was not ok");
              return response.json();
            })
            .then((data) => {
              submit.setAttribute('disabled', false)
              loader.classList.add('hidden')
              message.innerText = data.message;
              setTimeout(() => {
                  form.remove();
                  message.classList.remove('hidden');
              }, 300)
            })
            .catch((error) => {
              console.error("There was a problem with the fetch operation:", error);
            });
          })
        })
      }

    return {
        init() {
            formSubmit()
            formValid()
        },
    }
}


export {
    handleFormSubmit,
};
